export const summaryCards = [
  {
    id: 'monthly-sales',
    label: 'Monthly Sales',
    value: '',
    detail: '',
  },
  {
    id: 'year-sales',
    label: 'Year Sales',
    value: '',
    detail: '',
  },
  {
    id: 'seaweeds-stocks',
    label: 'Seaweeds Stocks (kg)',
    value: '',
    detail: '',
  },
  {
    id: 'expected-income',
    label: 'Expected Income',
    value: '',
    detail: '',
  },
  {
    id: 'supplier-cash-advance',
    label: 'Total Suppliers Cash Advance (S)',
    value: '',
    detail: '',
  },
  {
    id: 'customer-balance',
    label: 'Total Customer Balance',
    value: '',
    detail: '',
  },
];

export const salesAnalytics = [];
